import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { scrollToTop } from '../utils/scrollToTop';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // This step owns its mount announcement and scroll (including StrictMode).
    if (!matchPath({ path: '/withdrawal/form' }, pathname)) scrollToTop();
  }, [pathname]);
  return null;
};

export default ScrollToTop;
